import { lowerCaseTrim } from "./lowerCaseTrim";
import { removeSpaces } from "./removeSpaces";

export function lowerCaseWithoutSpaces(value: string) {
  const lower = lowerCaseTrim(value);
  const withoutSpaces = removeSpaces(lower);
  return withoutSpaces;
}
